/**
 * Impresión del ticket.
 *
 * Hoy se imprime con `window.print()` y la regla `@media print` de index.css
 * (solo #print-area, 80 mm). Con Chrome abierto con `--kiosk-printing` (ver
 * docs/impresion.md) sale directo a la impresora predeterminada, sin diálogo.
 */

const AUTO_PRINT_KEY = "pos.print.auto";

/** ¿Esta caja imprime sola al emitir? Preferencia del equipo, no del usuario. */
export function getAutoPrint(): boolean {
  try {
    return window.localStorage.getItem(AUTO_PRINT_KEY) === "1";
  } catch {
    return false;
  }
}

export function setAutoPrint(enabled: boolean): void {
  try {
    if (enabled) window.localStorage.setItem(AUTO_PRINT_KEY, "1");
    else window.localStorage.removeItem(AUTO_PRINT_KEY);
  } catch {
    /* modo privado o almacenamiento bloqueado: queda solo para esta sesión */
  }
}

const PRINTED_KEY = "pos.print.done";

/** Marca la venta como impresa (por pestaña) para no reimprimir al recargar. */
export function markPrinted(saleId: string): boolean {
  try {
    const done = new Set((window.sessionStorage.getItem(PRINTED_KEY) ?? "").split(","));
    if (done.has(saleId)) return false;
    done.add(saleId);
    // Solo las últimas 50: la lista no crece sin límite en un turno largo.
    window.sessionStorage.setItem(PRINTED_KEY, [...done].filter(Boolean).slice(-50).join(","));
    return true;
  } catch {
    return true;
  }
}
